<template>
  <div
    class="sub-question-list-dialog"
    :class="{ expanded: isExpanded }"
    ref="sheet"
  >
    <div
      class="handle"
      @touchstart="handleTouchStart"
      @touchmove="handleTouchMove"
      @touchend="handleTouchEnd"
    >
      <span></span>
    </div>
    <div class="question-cont">
      <!-- 小题序号列表 -->
      <div class="sub-index-list nested-scrollable">
        <div class="scroll-content" ref="scrollContent">
          <div class="tablist-wrap">
            <div
              :id="'tab-item-' + subQuestionInfo.id"
              class="subIndex-item"
              v-for="subQuestionInfo in hadleQuestionChild"
              :key="subQuestionInfo.id + '_index'"
              :class="handleSubIndexClass(subQuestionInfo)"
              @click="handleSubIndexClick(subQuestionInfo)"
            >
              {{ questionIndexObj[subQuestionInfo.id] + 1 }}
            </div>
          </div>
        </div>
      </div>
      <!-- 小题列表滚动区域 -->
      <swiper
        class="sub-question-list-swiper swiper-container"
        :options="swiperOption"
        ref="subQuestionListSwiper"
        :key="questionInfo.id"
      >
        <swiperSlide
          v-for="subQuestionInfo in hadleQuestionChild"
          :key="subQuestionInfo.id"
          class="sub_question_item_slider"
        >
          <choice-question
            :question-info="subQuestionInfo"
            :questionTypeFiexd="false"
          />
          <!-- 右侧固定区域 -->
          <div class="fixed-options-tips">
            <span v-for="item in subQuestionInfo.option.length" :key="item">
              {{ getLetter(item - 1) }}</span
            >
          </div>
        </swiperSlide>
      </swiper>
    </div>
  </div>
</template>

<script>
import {
  QUESTION_TYPE_NAME,
  WORK_STATUS,
} from "@saas/components/src/constants/question";
import { EventBus } from "@saas/components/src/utils/event-bus";
import ChoiceQuestion from "@saas/pages/src/homework/components-mobile/ChoiceQuestion.vue";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/css/swiper.css";
import { mapState, mapMutations, mapActions, mapGetters } from "vuex";
import { isHXApp } from "@saas/components";
export default {
  props: {
    questionInfo: {
      type: Object,
      default: () => ({}),
    },
    value: {
      type: Number,
      default: null,
    },
    swiperIndex: {
      type: Number,
      default: null,
    },
  },
  data() {
    let _this = this;
    return {
      startY: 0,
      startHeight: 0,
      isExpanded: true,
      minHeight: 1.9 * (window.innerWidth / 10), // 最小高度
      maxHeight: window.innerHeight - 4.8 * (window.innerWidth / 10), // 最大高度
      swiperOption: {
        autoplay: false,
        loop: false,
        observer: true,
        observeParents: true,
        on: {
          slideChangeTransitionEnd: function () {
            const subQuestionId = _this.hadleQuestionChild[this.realIndex]?.id;
            _this.$emit("input", subQuestionId);
            _this.setActiveIndex(_this.showQuestionIndexObj[subQuestionId]);
            _this.scrollActiveTab(subQuestionId);
          },
        },
      },
    };
  },
  created() {
    if (isHXApp() && window?.deviceSpace?.top) {
      this.maxHeight = this.maxHeight - window.deviceSpace.top; // 最大高度
    }
  },
  mounted() {
    EventBus.$off(`handleSlideChangeEnd${this.swiperIndex}`);
    EventBus.$on(`handleSlideChangeEnd${this.swiperIndex}`, () => {
      console.log(this.activeSubId, "this.activeSubId");

      this.setActiveIndex(this.showQuestionIndexObj[this.value]);
    });
    EventBus.$off(`changeSubQuestion${this.questionInfo.id}`);
    EventBus.$on(
      `changeSubQuestion${this.questionInfo.id}`,
      this.handleSubIndexClick
    );
    this.$emit("input", this.hadleQuestionChild?.[0]?.id);
  },
  methods: {
    ...mapMutations("defaultHomework", ["setActiveIndex"]),
    // 小题序号自动滚动
    scrollActiveTab(id) {
      if (this.$refs.scrollContent) {
        let itemEle = document.getElementById(`tab-item-${id}`);
        let totalWidth = this.$refs?.scrollContent?.offsetWidth || 0;
        let num = totalWidth * 0.45;
        if (itemEle?.offsetLeft > num) {
          this.$refs.scrollContent.scrollLeft = itemEle.offsetLeft - num;
        } else {
          this.$refs.scrollContent.scrollLeft = 0;
        }
      }
    },
    // 根据索引获取对应的字母（A、B、C、D）
    getLetter(index) {
      return String.fromCharCode(65 + index);
    },
    handleSubIndexClick(subQuestionInfo) {
      let { id, subIndex, big_question_type } = subQuestionInfo;
      if (this.showSingleQuestion) {
        this.$emit("input", id);
      } else {
        // 阅读理解
        this.changing = true;
        this.$emit("input", id);
      }
      if (this.showErrorAnalysis) {
        subIndex = this.hadleQuestionChild.findIndex((item) => item.id === id);
      }
      this.swiper.slideTo(subIndex); //swiper滑动到相对应的滑块
      this.scrollActiveTab(id);
      // 题干区域滚动到顶部
      // console.log(document.querySelector(`.question-btn-${id}`).offsetTop);
      console.log(document.querySelector(`.question-btn-${id}`), id);
      if (big_question_type === QUESTION_TYPE_NAME.COMPLETE_BLANK_FILL) {
        let el = document.querySelector(`.question-btn-${id}`);
        el.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }
    },
    setSheetHeight(height) {
      // 设置弹窗的高度，同时保证高度在最小和最大高度之间
      this.$refs.sheet.style.height = `${Math.min(
        this.maxHeight,
        Math.max(this.minHeight, height)
      )}px`;
    },
    handleTouchStart(e) {
      this.$refs.sheet.style.transition = "none";
      this.startY = e.touches[0].clientY;
      this.startHeight = parseInt(getComputedStyle(this.$refs.sheet).height);
      this.isExpanded = true;
    },
    handleTouchMove(e) {
      // 阻止默认的触摸事件，防止页面滚动
      e.preventDefault();
      const currentY = e.touches[0].clientY;
      const distance = currentY - this.startY;
      // 根据拖拽距离计算新的高度
      const newHeight = this.startHeight - distance;
      this.setSheetHeight(newHeight);
    },
    handleTouchEnd() {
      this.$refs.sheet.style.transition = "height 0.3s ease-in-out";
      setTimeout(() => {
        this.$emit(
          "dialog-height-change",
          Number(this.$refs.sheet.style.height.replace("px", ""))
        );
      }, 320);
    },
  },
  computed: {
    ...mapState("defaultHomework", [
      "workInfo",
      "questionList",
      "isCorrected",
      "showErrorAnalysis",
    ]),
    ...mapGetters("defaultHomework", [
      "showQuestionIndexObj",
      "questionIndexObj",
    ]),
    hadleQuestionChild() {
      if (this.showErrorAnalysis) {
        return this.questionInfo?.errorChild || [];
      } else {
        return this.questionInfo.child || [];
      }
    },
    handleSubIndexClass() {
      return (subQuestionInfo) => {
        const { right, userAnswer } = subQuestionInfo;
        return {
          "is-active": this.value === subQuestionInfo.id,
          "is-answer": userAnswer,
          "is-right": this.isCorrected && userAnswer && right === 1,
          "is-wrong": this.isCorrected && userAnswer && right === 2,
        };
      };
    },
    swiper() {
      return this.$refs.subQuestionListSwiper.swiper;
    },
  },
  components: {
    swiper,
    swiperSlide,
    ChoiceQuestion,
  },
};
</script>

<style lang="scss" scoped>
.sub-question-list-dialog {
  position: absolute;
  width: 100%;
  left: 0;
  bottom: 0;
  background: #fff;
  z-index: 99;
  box-shadow: 0rem -0.11rem 0.16rem 0rem rgba(29, 33, 41, 0.05);
  border-radius: 0.32rem 0.32rem 0rem 0rem;
  overflow: hidden;
}
.handle {
  height: 0.69rem;
  display: flex;
  align-items: center;
  justify-content: center;
  user-select: none;
  span {
    width: 0.8rem;
    height: 0.11rem;
    background: #f2f3f5;
    border-radius: 0.05rem;
  }
}
.sheet {
  background-color: white;
  width: 100%;
  position: absolute;
  bottom: 0;
  left: 0;
  transition: height 0.3s ease-in-out;
  height: 0; /* 初始高度为 0 */
}
.expanded {
  height: 45vh; /* 展开时的高度 */
}
.question-cont {
  height: calc(100% - 0.69rem);
}
.sub-index-list {
  height: 1.15rem;
  display: flex;
  overflow: hidden;
  border-bottom: 0.03rem solid #f2f3f5;
  .scroll-content {
    scrollbar-width: 0;
    /* 标准语法，Firefox 支持 */
    -ms-overflow-style: none;
    /* IE 和 Edge */
    &::-webkit-scrollbar {
      display: none;
      /* WebKit 内核浏览器 */
    }
    scroll-snap-type: x mandatory;
    overflow-x: scroll;
    overflow-y: hidden;
    scroll-behavior: smooth;
    overscroll-behavior: contain;
  }
  .tablist-wrap {
    display: flex;
    align-items: center;
    flex-wrap: nowrap;
    width: max-content;
    padding-left: 0.37rem;
  }
  .subIndex-item {
    width: 0.8rem;
    height: 0.8rem;
    background: #f2f3f5;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 600;
    font-size: 0.37rem;
    color: #4e5969;
    border: 0.03rem solid #f2f3f5;
    margin-right: 0.37rem;
    &.is-active {
      border-color: #86909c;
      color: #4e5969;
      background-color: #f2f3f5;
    }
    &.is-answer {
      background: $homework-default-bg;
      color: $homework-default-color;
      border-color: $homework-default-bg;
      &.is-active {
        border-color: #386bff;
      }
    }
    &.is-right {
      background: $homework-right-bg;
      color: $homework-right-color;
      border-color: $homework-right-bg;
      &.is-active {
        border-color: $homework-right-color;
      }
    }
    &.is-wrong {
      background: $homework-wrong-bg;
      color: $homework-wrong-color;
      border-color: $homework-wrong-bg;
      &.is-active {
        border-color: $homework-wrong-color;
      }
    }
  }
}

.sub-question-list-swiper {
  height: calc(100% - 1.15rem);
  .sub_question_item_slider {
    width: 100% !important;
    height: 100%;
    overflow-y: auto;
    overflow-x: hidden;
    padding: 0.32rem 0.16rem 0.32rem 0.43rem;
    position: relative;
    .mobile-question-wrap {
      padding-right: 0.8rem;
    }
    .fixed-options-tips {
      position: absolute;
      right: 0.3rem;
      top: 0.35rem;
      width: 0.24rem;
      font-weight: 500;
      font-size: 0.32rem;
      color: #c9cdd4;
      line-height: 0.45rem;
      display: flex;
      flex-direction: column;
      align-items: center;
    }
  }
}
</style>
